// extracted by mini-css-extract-plugin
export default {"container":"StudyList_container__A773l","card":"StudyList_card__VY-72","cardFooter":"StudyList_cardFooter__YG6GX"};